module.exports = __webpack_public_path__ + "static/media/arrowBlackTop.bc8e3d73.svg";